// src/components/AuthHandler/AuthHandler.js
import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // Correct import for v3+
import { AuthContext } from "../../context/AuthContext";


const AuthHandler = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext); // use context to update user globally

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("access_token") || params.get("token");


    if (token) {
      try {
        const userData = jwtDecode(token); // decode token
        login(userData, token); // update context and localStorage
        navigate("/buy"); // redirect to buy page
      } catch (error) {
        console.error("Invalid token:", error);
        navigate("/"); // redirect to home/login if decoding fails
      }
    } else {
      navigate("/login"); // redirect if no token found
    }
  }, [login, navigate]);

  return <p>Logging you in...</p>;
};

export default AuthHandler;

